import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
    name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
    transform(value: number | string, locale?: string): string {
        return new Intl.NumberFormat(locale, {
            minimumFractionDigits: 2
        }).format(Number(value));
        // return value.toLocaleString(['ban', 'id']);
    }
}
